import { z } from "zod";

import { AlertCodeSchema, AlertConfigSchema } from "../alertCodes";
import {
  CompanyMachineSchema,
  IndustrialProcessSchema,
  MachineSchema,
  MaterialLayoutSchema,
  ProcessStepSchema,
  ProductLineSchema,
} from "./PrismaZod";

const _ProcessStepSchemaWithRelations = ProcessStepSchema.merge(
  z.object({
    margin: z.number().nullable().optional(),
    companyMachine: CompanyMachineSchema.merge(
      z.object({
        machine: MachineSchema.omit({
          createdAt: true,
          updatedAt: true,
          companyId: true,
          internalId: true,
        }),
      }),
    )
      .partial()
      .nullable(),
    materialLayout: MaterialLayoutSchema.pick({
      quantity: true,
      price: true,
      length: true,
      width: true,
      height: true,
      type: true,
    })
      .partial()
      .nullable(),
    productLines: ProductLineSchema.pick({
      quantity: true,
      price: true,
      fixedPrice: true,
    })
      .extend({
        fixedPrice: z.union([z.number(), z.null(), z.undefined()]),
      })
      .array(),
  }),
)
  .partial()
  .merge(z.object({ industrialProcess: IndustrialProcessSchema }));

export type ProcessStep = z.infer<typeof _ProcessStepSchemaWithRelations>;

const ProcessStepAlertGenericSchema = z.record(
  z.string(),
  z.union([z.number(), z.boolean(), z.string()]),
);

const ProcessStepAlertStaticSchema = AlertConfigSchema.extend({
  code: AlertCodeSchema,
  extended_description: z.string().optional(),
});

export const ProcessStepAlertSchema = z.object({
  raise_alert: z.boolean().optional(),
  isOverwrittenByFormula: z
    .object({
      otherMachineTime: z.boolean().optional(),
    })
    .optional(),
  conditions: z
    .object({
      static_rule: z
        .union([ProcessStepAlertGenericSchema, ProcessStepAlertStaticSchema])
        .optional(),
    })
    .optional(),
});
export type ProcessStepAlertStatic = z.infer<typeof ProcessStepAlertStaticSchema>;
export type ProcessStepAlert = z.infer<typeof ProcessStepAlertSchema>;
